import { Link } from 'react-router';
import {
  Container,
  Group,
  Stack,
  Text,
  Anchor,
  SimpleGrid,
  Box,
  Divider,
} from '@mantine/core';
import {
  IconHeart,
  IconPhone,
  IconMail,
  IconMapPin,
  IconClock,
} from '@tabler/icons-react';
import classes from './Footer.module.css';

const links = [
  { link: '/', label: 'Home' },
  { link: '/services', label: 'Services' },
  { link: '/about', label: 'About Us' },
  { link: '/contact', label: 'Contact' },
];

export function Footer() {
  return (
    <Box component="footer" className={classes.footer}>
      <Container size="xl" py="xl">
        <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }} spacing="xl">
          <Stack gap="md">
            <Group gap="xs">
              <IconHeart size={28} stroke={1.5} color="var(--mantine-color-harmony-4)" aria-hidden="true" />
              <Box>
                <Text fw={700} size="lg" c="white" lh={1.2}>
                  Hillside Harmony
                </Text>
                <Text size="xs" c="gray.4" lh={1}>
                  Assisted Living with Heart
                </Text>
              </Box>
            </Group>
            <Text size="sm" c="gray.4" maw={300}>
              Providing compassionate, personalized care in a warm, home-like environment where every resident is treated like family.
            </Text>
          </Stack>

          <Stack gap="sm" component="nav" aria-label="Footer navigation">
            <Text fw={600} c="white" mb="xs">
              Quick Links
            </Text>
            {links.map((link) => (
              <Anchor
                key={link.label}
                component={Link}
                to={link.link}
                c="gray.4"
                size="sm"
                className={classes.link}
              >
                {link.label}
              </Anchor>
            ))}
          </Stack>

          <Stack gap="sm">
            <Text fw={600} c="white" mb="xs">
              Contact Us
            </Text>
            <Group gap="xs" wrap="nowrap">
              <IconPhone size={16} color="var(--mantine-color-harmony-4)" aria-hidden="true" />
              <Anchor href="tel:+16514000063" c="gray.4" size="sm" className={classes.link}>
                (651) 400-0063
              </Anchor>
            </Group>
            <Group gap="xs" wrap="nowrap">
              <IconMail size={16} color="var(--mantine-color-harmony-4)" aria-hidden="true" />
              <Anchor href="mailto:info@hillsideharmony.com" c="gray.4" size="sm" className={classes.link}>
                info@hillsideharmony.com
              </Anchor>
            </Group>
            <Group gap="xs" wrap="nowrap" align="flex-start">
              <IconMapPin size={16} color="var(--mantine-color-harmony-4)" style={{ marginTop: 3 }} aria-hidden="true" />
              <Text c="gray.4" size="sm">
                135 Geranium Ave E<br />
                Saint Paul, MN 55117
              </Text>
            </Group>
          </Stack>

          <Stack gap="sm">
            <Text fw={600} c="white" mb="xs">
              Hours
            </Text>
            <Group gap="xs" wrap="nowrap" align="flex-start">
              <IconClock size={16} color="var(--mantine-color-harmony-4)" style={{ marginTop: 3 }} aria-hidden="true" />
              <Box>
                <Text c="gray.4" size="sm" fw={500}>
                  Tours & Visits
                </Text>
                <Text c="gray.4" size="sm">
                  Mon - Fri: 9am - 5pm<br />
                  Sat: 10am - 3pm<br />
                  Sun: By Appointment
                </Text>
              </Box>
            </Group>
          </Stack>
        </SimpleGrid>

        <Divider my="xl" color="gray.8" />

        <Group justify="space-between" wrap="wrap" gap="sm">
          <Text size="xs" c="gray.5">
            &copy; {new Date().getFullYear()} Hillside Harmony Assisted Living. All rights reserved.
          </Text>
          <Group gap="md">
            <Anchor href="/privacy" c="gray.5" size="xs" className={classes.link}>
              Privacy Policy
            </Anchor>
            <Anchor href="/terms" c="gray.5" size="xs" className={classes.link}>
              Terms of Service
            </Anchor>
          </Group>
        </Group>
      </Container>
    </Box>
  );
}
